module.exports = __webpack_public_path__ + "static/media/icon_car_back_side.9f20d380.svg";